const FADE_OFFSET_Y = 6;
const FADE_BLUR = 12;
const FADE_SPREAD = 8;

export const GRID_SURFACE_BASE_VAR = '--grid-surface-base';
export const GRID_SURFACE_TINT_VAR = '--grid-surface-tint';

interface GridSurfaceParams {
  base: string;
  tint?: string;
}

export const getTintedSurface = ({ base, tint }: GridSurfaceParams) => ({
  backgroundColor: base,
  backgroundImage: tint ? `linear-gradient(${tint}, ${tint})` : 'none',
});

export const getGridSurface = ({ base, tint }: GridSurfaceParams) => ({
  [GRID_SURFACE_BASE_VAR]: base,
  [GRID_SURFACE_TINT_VAR]: tint ?? 'transparent',
});

export const getGridSurfaceStyles = (params: GridSurfaceParams) => ({
  ...getTintedSurface(params),
  ...getGridSurface(params),
});

const getFadeLayer = (color: string) =>
  `0px ${FADE_OFFSET_Y}px ${FADE_BLUR}px ${FADE_SPREAD}px ${color}`;

export const getGridScrollFadeShadow = ({ base, tint }: GridSurfaceParams) =>
  tint ? `${getFadeLayer(tint)}, ${getFadeLayer(base)}` : getFadeLayer(base);
